export default __webpack_public_path__ + "img/fVxdNyBl.cf9a0b36.svg";